<template>
  <div class="questionnaire-question-grid -double-">
    <ol>
      <li>
        Суммируй свои показатели по выручке и прибыли за весь предыдущий год,
        посчитай каждый из них отдельно. Год может быть как календарным,
        так и 12 месяцев назад с текущей даты.
      </li>
      <li>Полученный результат за год раздели на 12 (12 месяцев в году).</li>
      <li>
        Так ты получишь свой средний результат по выручке и прибыли за месяц.
        Введи их в соответствующие поля анкеты.
      </li>
      <li>
        Если у тебя нет данных за целый год, суммируй отдельно выручку и прибыль
        за известный период. Каждую из сумм подели на количество месяцев.
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'RevenueProfitHelper'
};
</script>

<style scoped lang="scss">
ol {
  list-style: auto;
  max-width: 600px;
  justify-self: center;
  li {
    margin-bottom: 16px;
    margin-left: 10px;
  }
}
</style>
